import emailjs from "@emailjs/browser";

export const useConfigStore = defineStore("config", () => {
    const transition = ref<string>("transition-all ease-in");

    const showToast = ref<boolean>(false)
    const toastMsg = ref<string>("")

    async function getProj() {
        try {
          const response = await fetch('https://stylforecast-api.onrender.com/portfolio/projects')
          if (!response.ok || response.status !== 200) {
            throw new Error('Can not Fetch Data')
          }
          return await response.json()
        }
        catch {
          console.error('[Error]: <stores.config> getProj')
          return [];
        }
    }

   async function getSingleProj(id: number) {
      try {
        const response = await fetch(`https://stylforecast-api.onrender.com/portfolio/projects/${id}`)
        if (!response.ok || response.status !== 200) {
          throw new Error('Can not Fetch Data')
        }
        return await response.json()
      }
      catch {
        console.error('[Error]: <stores.config> getProj')
        return null;
      }
    }

    const sentEmail = (credentials: Credentials, form: any) => {
        const {fullname, email, textbox} = credentials;
        if (fullname === ""  || email === "" || (textbox === "" || (textbox.length<15 || textbox.length>100))) return ;
        emailjs.sendForm(import.meta.env.VITE_EMAIL_SERVICE, import.meta.env.VITE_EMAIL_TEMPLATE, form, {
            publicKey: import.meta.env.VITE_EMAIL_KEY,
        })
            .then(
                () => {
                    showToast.value = true
                    toastMsg.value = "Email sent Successfully!"
                },
                () => {
                    showToast.value = true
                    toastMsg.value = "Error while sending the email"
                },
            );
    }

    const openMenu = ref<boolean>(false);

    return { openMenu, sentEmail, transition, showToast, toastMsg, getProj, getSingleProj}
})
